var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popup-panel" },
    [
      _vm.opportunity.display
        ? _c(
            "opportunity-form",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "opportunityForm" })
                  }
                }
              },
              "opportunity-form",
              _vm.opportunity.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.addressForm.display
        ? _c(
            "address-form",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "addressForm" })
                  }
                }
              },
              "address-form",
              _vm.addressForm.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customfield.display
        ? _c(
            "customfields-form",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "customfieldForm" })
                  }
                }
              },
              "customfields-form",
              _vm.customfield.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.document.display
        ? _c(
            "document-preview",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "documentPreview" })
                  }
                }
              },
              "document-preview",
              _vm.document.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emailOnboarding.display
        ? _c(
            "email-onboarding",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "emailOnboarding" })
                  }
                }
              },
              "email-onboarding",
              _vm.emailOnboarding.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emailConnectionfailed.display
        ? _c(
            "email-connection-failed",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "emailConnectionfailed" })
                  }
                }
              },
              "email-connection-failed",
              _vm.emailConnectionfailed.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.addRecurringTerm.display
        ? _c(
            "add-recurring-term-component",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "addRecurringTerm" })
                  }
                }
              },
              "add-recurring-term-component",
              _vm.addRecurringTerm.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.changeOwner.display
        ? _c(
            "change-owner-component",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "changeOwner" })
                  }
                }
              },
              "change-owner-component",
              _vm.changeOwner.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.changeGenerationMode.display
        ? _c(
            "change-generation-mode-component",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "changeGenerationMode" })
                  }
                }
              },
              "change-generation-mode-component",
              _vm.changeGenerationMode.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.documentValidation.display
        ? _c(
            "document-validation",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "documentValidation" })
                  }
                }
              },
              "document-validation",
              _vm.documentValidation.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.avatarUploader.display
        ? _c(
            "avatar-uploader",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "avatarUploader" })
                  }
                }
              },
              "avatar-uploader",
              _vm.avatarUploader.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupAprilTeamPosition.display
        ? _c(
            "popup-april-team-position",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupAprilTeamPosition" })
                  }
                }
              },
              "popup-april-team-position",
              _vm.popupAprilTeamPosition.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.transferTransactionForm.display
        ? _c("transfer-transaction-form", {
            on: {
              close: function($event) {
                return _vm.close({ key: "transferTransactionForm" })
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.calendarView.display
        ? _c(
            "calendar-view",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "calendarView" })
                  }
                }
              },
              "calendar-view",
              _vm.calendarView.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.staffForm.display
        ? _c(
            "staff-form",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "staffForm" })
                  }
                }
              },
              "staff-form",
              _vm.staffForm.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupQuotaLimit.display
        ? _c(
            "popup-quota-limit",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupQuotaLimit" })
                  }
                }
              },
              "popup-quota-limit",
              _vm.popupQuotaLimit.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupMailchimpSettings.display
        ? _c(
            "popup-mailchimp-settings",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupMailchimpSettings" })
                  }
                }
              },
              "popup-mailchimp-settings",
              _vm.popupMailchimpSettings.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupMailjetSettings.display
        ? _c(
            "popup-mailjet-settings",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupMailjetSettings" })
                  }
                }
              },
              "popup-mailjet-settings",
              _vm.popupMailjetSettings.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupMassEditPrefs.display
        ? _c(
            "popup-mass-edit-prefs",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupMassEditPrefs" })
                  }
                }
              },
              "popup-mass-edit-prefs",
              _vm.popupMassEditPrefs.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupMassEditVatMode.display
        ? _c(
            "popup-mass-edit-vat-mode",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupMassEditVatMode" })
                  }
                }
              },
              "popup-mass-edit-vat-mode",
              _vm.popupMassEditVatMode.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupSchedulerSettings.display
        ? _c(
            "popup-scheduler-settings",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupSchedulerSettings" })
                  }
                }
              },
              "popup-scheduler-settings",
              _vm.popupSchedulerSettings.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.esignPopupProvider.display
        ? _c(
            "esign-popup-provider",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "esignPopupProvider" })
                  }
                }
              },
              "esign-popup-provider",
              _vm.esignPopupProvider.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupManagerPaymentCard.display
        ? _c(
            "popup-manager-payment-card",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupManagerPaymentCard" })
                  }
                }
              },
              "popup-manager-payment-card",
              _vm.popupManagerPaymentCard.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.corp2FAToggle.display
        ? _c(
            "Corp2FAToggle",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "corp2FAToggle" })
                  }
                }
              },
              "Corp2FAToggle",
              _vm.corp2FAToggle.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.backupCodes2FA.display
        ? _c(
            "BackupCodes2FA",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "backupCodes2FA" })
                  }
                }
              },
              "BackupCodes2FA",
              _vm.backupCodes2FA.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deactivate2FA.display
        ? _c(
            "Deactivate2FA",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "deactivate2FA" })
                  }
                }
              },
              "Deactivate2FA",
              _vm.deactivate2FA.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.removeTrustedDevice.display
        ? _c(
            "RemoveTrustedDevice",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "removeTrustedDevice" })
                  }
                }
              },
              "RemoveTrustedDevice",
              _vm.removeTrustedDevice.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activate2FAProvider.display
        ? _c(
            "Activate2FAProvider",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "activate2FAProvider" })
                  }
                }
              },
              "Activate2FAProvider",
              _vm.activate2FAProvider.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.adyenPopup.display
        ? _c(
            "AdyenPopup",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "adyenPopup" })
                  }
                }
              },
              "AdyenPopup",
              _vm.adyenPopup.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cashflowPopupWarning.display
        ? _c(
            "CashflowPopupWarning",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "cashflowPopupWarning" })
                  }
                }
              },
              "CashflowPopupWarning",
              _vm.cashflowPopupWarning.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupCheckSendingEmail.display
        ? _c(
            "PopupCheckSendingEmail",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupCheckSendingEmail" })
                  }
                }
              },
              "PopupCheckSendingEmail",
              _vm.popupCheckSendingEmail.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.importRevertPopup.display
        ? _c(
            "ImportRevertPopup",
            _vm._b(
              {
                on: {
                  closed: function($event) {
                    return _vm.close({ key: "importRevertPopup" })
                  }
                }
              },
              "ImportRevertPopup",
              _vm.importRevertPopup.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.importCancelPopup.display
        ? _c(
            "ImportCancelPopup",
            _vm._b(
              {
                on: {
                  closed: function($event) {
                    return _vm.close({ key: "importCancelPopup" })
                  }
                }
              },
              "ImportCancelPopup",
              _vm.importCancelPopup.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.importDetailPopup.display
        ? _c(
            "ImportDetailPopup",
            _vm._b(
              {
                on: {
                  closed: function($event) {
                    return _vm.close({ key: "importDetailPopup" })
                  }
                }
              },
              "ImportDetailPopup",
              _vm.importDetailPopup.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.onboardingScreenPanel.display
        ? _c(
            "OnboardingScreenPanel",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "onboardingScreenPanel" })
                  }
                }
              },
              "OnboardingScreenPanel",
              _vm.onboardingScreenPanel.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.featureModal.display
        ? _c(
            "UpsellFeatureModal",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "featureModal" })
                  }
                }
              },
              "UpsellFeatureModal",
              _vm.featureModal.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.aiCancelModal.display
        ? _c(
            "AICancelModal",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "aiCancelModal" })
                  }
                }
              },
              "AICancelModal",
              _vm.aiCancelModal.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activityFormPanel.display
        ? _c(
            "ActivityFormPanel",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "activityFormPanel" })
                  }
                }
              },
              "ActivityFormPanel",
              _vm.activityFormPanel.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.phoneCallFormPanel.display
        ? _c(
            "PhoneCallFormPanel",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "phoneCallFormPanel" })
                  }
                }
              },
              "PhoneCallFormPanel",
              _vm.phoneCallFormPanel.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activityDetailPanel.display
        ? _c(
            "ActivityDetailPanel",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "activityDetailPanel" })
                  }
                }
              },
              "ActivityDetailPanel",
              _vm.activityDetailPanel.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activityDeleteDialog.display
        ? _c(
            "ActivityDeleteDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "activityDeleteDialog" })
                  }
                }
              },
              "ActivityDeleteDialog",
              _vm.activityDeleteDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activitiesListingMassReschedule.display
        ? _c(
            "ActivitiesListingMassReschedule",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "activitiesListingMassReschedule" })
                  }
                }
              },
              "ActivitiesListingMassReschedule",
              _vm.activitiesListingMassReschedule.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.popupMarkPhoneCallDone.display
        ? _c(
            "PopupMarkPhoneCallDone",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "popupMarkPhoneCallDone" })
                  }
                }
              },
              "PopupMarkPhoneCallDone",
              _vm.popupMarkPhoneCallDone.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activitiesMassMarkAsDone.display
        ? _c(
            "ActivitiesMassMarkAsDone",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "activitiesMassMarkAsDone" })
                  }
                }
              },
              "ActivitiesMassMarkAsDone",
              _vm.activitiesMassMarkAsDone.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activitiesListingMassModifyOwner.display
        ? _c(
            "ActivitiesListingMassModifyOwner",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({
                      key: "activitiesListingMassModifyOwner"
                    })
                  }
                }
              },
              "ActivitiesListingMassModifyOwner",
              _vm.activitiesListingMassModifyOwner.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activitiesListingMassAssign.display
        ? _c(
            "ActivitiesListingMassAssign",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "activitiesListingMassAssign" })
                  }
                }
              },
              "ActivitiesListingMassAssign",
              _vm.activitiesListingMassAssign.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activitiesListingMassDelete.display
        ? _c(
            "ActivitiesListingMassDelete",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "activitiesListingMassDelete" })
                  }
                }
              },
              "ActivitiesListingMassDelete",
              _vm.activitiesListingMassDelete.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.myActivitiesCardConfigDialog.display
        ? _c(
            "MyActivitiesCardConfigDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "myActivitiesCardConfigDialog" })
                  }
                }
              },
              "MyActivitiesCardConfigDialog",
              _vm.myActivitiesCardConfigDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.connectionConsentDialog.display
        ? _c(
            "ConnectionConsentDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "connectionConsentDialog" })
                  }
                }
              },
              "ConnectionConsentDialog",
              _vm.connectionConsentDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activitiesLinkObjectDialog.display
        ? _c(
            "ActivitiesLinkObjectDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "activitiesLinkObjectDialog" })
                  }
                }
              },
              "ActivitiesLinkObjectDialog",
              _vm.activitiesLinkObjectDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.createProgressInvoiceBlockByDraftDialog.display
        ? _c(
            "CreateProgressInvoiceBlockByDraftDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({
                      key: "createProgressInvoiceBlockByDraftDialog"
                    })
                  }
                }
              },
              "CreateProgressInvoiceBlockByDraftDialog",
              _vm.createProgressInvoiceBlockByDraftDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogValidateProgressInvoice.display
        ? _c(
            "DialogValidateProgressInvoice",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "dialogValidateProgressInvoice" })
                  }
                }
              },
              "DialogValidateProgressInvoice",
              _vm.dialogValidateProgressInvoice.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelProgressInvoiceDialog.display
        ? _c(
            "CancelProgressInvoiceDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "cancelProgressInvoiceDialog" })
                  }
                }
              },
              "CancelProgressInvoiceDialog",
              _vm.cancelProgressInvoiceDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emailDeleteConfirmDialog.display
        ? _c(
            "EmailListingDeleteConfirmDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "emailDeleteConfirmDialog" })
                  }
                }
              },
              "EmailListingDeleteConfirmDialog",
              _vm.emailDeleteConfirmDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.documentHasProgressInvoiceDialog.display
        ? _c(
            "DocumentHasProgressInvoiceDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({
                      key: "documentHasProgressInvoiceDialog"
                    })
                  }
                }
              },
              "DocumentHasProgressInvoiceDialog",
              _vm.documentHasProgressInvoiceDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.alert.display
        ? _c(
            "AlertDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "alert" })
                  }
                }
              },
              "AlertDialog",
              _vm.alert.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogMissingFeaturesProgressInvoice.display
        ? _c(
            "DialogMissingFeaturesProgressInvoice",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({
                      key: "dialogMissingFeaturesProgressInvoice"
                    })
                  }
                }
              },
              "DialogMissingFeaturesProgressInvoice",
              _vm.dialogMissingFeaturesProgressInvoice.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dialogProgressInvoiceSelectType.display
        ? _c(
            "DialogProgressInvoiceSelectType",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "dialogProgressInvoiceSelectType" })
                  }
                }
              },
              "DialogProgressInvoiceSelectType",
              _vm.dialogProgressInvoiceSelectType.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contactPanel.display
        ? _c(
            "ContactPanel",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "contactPanel" })
                  }
                }
              },
              "ContactPanel",
              _vm.contactPanel.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.automationDeleteDialog.display
        ? _c(
            "AutomationDeleteDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "automationDeleteDialog" })
                  }
                }
              },
              "AutomationDeleteDialog",
              _vm.automationDeleteDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.automationRenameDialog.display
        ? _c(
            "AutomationRenameDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "automationRenameDialog" })
                  }
                }
              },
              "AutomationRenameDialog",
              _vm.automationRenameDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.automationWizardPanel.display
        ? _c("AutomationWizardPanel", {
            attrs: {
              template: _vm.automationWizardPanel.props.template,
              showPanel: _vm.automationWizardPanel.display
            },
            on: {
              close: function($event) {
                return _vm.close({ key: "automationWizardPanel" })
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.docFormErrorDialog.display
        ? _c(
            "DocFormErrorDialog",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "docFormErrorDialog" })
                  }
                }
              },
              "DocFormErrorDialog",
              _vm.docFormErrorDialog.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.documentNotAuthorized.display
        ? _c(
            "DialogDocumentNotAuthorized",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "documentNotAuthorized" })
                  }
                }
              },
              "DialogDocumentNotAuthorized",
              _vm.documentNotAuthorized.props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.customfieldHistoryPanel.display
        ? _c(
            "CustomfieldHistoryPanel",
            _vm._b(
              {
                on: {
                  close: function($event) {
                    return _vm.close({ key: "customfieldHistoryPanel" })
                  }
                }
              },
              "CustomfieldHistoryPanel",
              _vm.customfieldHistoryPanel.props,
              false
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }